import { useState, useEffect } from 'react';
import { X, Users, ScrollText, Activity, ShieldCheck } from 'lucide-react';
import { UsersTab } from './manage/UsersTab';
import { AuditLogTab } from './manage/AuditLogTab';
import { TrackerLogTab } from './manage/TrackerLogTab';
import { AccessRequestsTab } from './manage/AccessRequestsTab';
type ManageTab = 'users' | 'audit-log' | 'tracker-log' | 'access-requests';
interface ManageModalProps {
  onClose: () => void;
}
const TABS: {
  key: ManageTab;
  label: string;
  icon: React.ReactNode;
}[] = [{
  key: 'users',
  label: 'Users',
  icon: <Users size={16} data-id="element-448" data-mp="2gzjq1l8fdkcz" />
}, {
  key: 'access-requests',
  label: 'Access Requests',
  icon: <ShieldCheck size={16} data-id="element-449" data-mp="2c0qcxtx1vvdc" />
}, {
  key: 'audit-log',
  label: 'Audit Log',
  icon: <ScrollText size={16} data-id="element-450" data-mp="27zwrr8azsuo5" />
}, {
  key: 'tracker-log',
  label: 'Tracker Log',
  icon: <Activity size={16} data-id="element-451" data-mp="10nwbyyigkp82" />
}];
export function ManageModal({
  onClose
}: ManageModalProps) {
  const [activeTab, setActiveTab] = useState<ManageTab>('users');

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-4 px-2" style={{
    background: 'rgba(0,0,0,0.55)'
  }} onClick={onClose} data-id="element-452" data-mp="1ezyigyue8ftl">
      <div className="relative bg-white rounded-xl shadow-2xl w-full flex flex-col" style={{
      maxWidth: '98vw',
      height: '95vh'
    }} onClick={e => e.stopPropagation()} data-id="element-453" data-mp="156rftlr1fdx7">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200" data-id="element-454" data-mp="v81vlmbo5hds">
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-455" data-mp="106myjtib2f5x">Manage</h2>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-456" data-mp="m9q8vvdxb3qm">
            <X size={20} data-id="element-457" data-mp="2syiigynwzs19" />
          </button>
        </div>

        {/* Body: sidebar + content */}
        <div className="flex flex-1 min-h-0" data-id="element-458" data-mp="2o5pdqasg4jp6">
          {/* Left sidebar */}
          <nav className="w-48 border-r border-slate-200 bg-slate-50 flex-shrink-0" data-id="element-459" data-mp="2j7e15sarnv39">
            <div className="py-3" data-id="element-460" data-mp="2f62d3r7jjhx6">
              {TABS.map(tab => <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium transition-colors ${activeTab === tab.key ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-600' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`} data-id="element-461" data-mp="2f7wu4ufoypvz">
                  {tab.icon}
                  {tab.label}
                </button>)}
            </div>
          </nav>

          {/* Content area */}
          <div className="flex-1 overflow-y-auto p-6" data-id="element-462" data-mp="1zm3qwc83ao9">
            {activeTab === 'users' && <UsersTab data-id="element-463" data-mp="6ygmxze3r18w" />}
            {activeTab === 'access-requests' && <AccessRequestsTab data-id="element-464" data-mp="6yyrdjax4lrw" />}
            {activeTab === 'audit-log' && <AuditLogTab data-id="element-465" data-mp="azis0wupa7is" />}
            {activeTab === 'tracker-log' && <TrackerLogTab data-id="element-466" data-mp="axxxh78dyokx" />}
          </div>
        </div>
      </div>
    </div>;
}